import React from "react";

const AIScreening = () =>{
    return(
        <>
            <h1>Coming Soon!!</h1>
        </>
    );
};

export default AIScreening;